// extracted by mini-css-extract-plugin
module.exports = {"container":"_1SN7Olv_1mfM3SrFpBe0w9"};